import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CellRenderer, CellRendererParams } from 'app/shared/components/smart-grid/core/interfaces/cell-renderer.interface';
import { QuotaAttributes } from '@albatrosdeveloper/ave-models-package';

/**
 * Group Renderer
 *
 *
 * @example
 * ```typescript
 * {
 *   field: 'type',
 *   headerName: 'Cliente',
 *   cellRenderer: ,
 *   minWidth: 200
 * }
 * ```
 */
@Component({
    selector: 'app-group-cell-renderer',
    standalone: true,
    imports: [CommonModule],
    template: `
    <div class="leading-tight">
        <b class="f-10" *ngIf="groupCode">
        {{ groupCode }} <br>
        </b>
        <span>{{ params.data?.materialGroupName }}</span>
    </div>
  `,
})
export class GroupCellRendererComponent implements CellRenderer<QuotaAttributes> {
    @Input() params!: CellRendererParams<QuotaAttributes>;

    get groupCode(): string | null {
        return this.params.data?.materialGroupCode;
    }
}